export const environment = {
    production: true,
    demo: 'demo1',
    // SERVER_URL: 'http://localhost:1337',
    SERVER_URL: 'https://indiapicture.com',
    backendUrl: 'https://indiapicture.com/api/api/indiapicture/',
    exclusiveBackendUrl: 'https://indiapicture.com/api/api/indiapictureexclusive/',
    budgetBackendUrl: 'https://indiapicture.com/api/api/indiapicturebudget/',
    // siteadminUrl: 'https://frontadmin.indiapicture.in/api/api/unauth/',
    siteadminUrl: 'https://admin.indiapicture.com/api/api/unauth/',
    frontUrl: 'https://indiapicture.com',
    searchhint: 'https://api.indiapicture.in/search.hint.php',
    headerType: 'banner',
    /*
     * Google sign-in and email-OTP sign-in, on BOTH login surfaces: the site's
     * indiapicture-login-modal and the AI Studio's own account dialog.
     *
     * A visibility switch only — the flows and their backends are always present.
     * false hides the Google button, the OTP/Password switch and the code panes,
     * and both surfaces fall back to email + password. Toggling it needs no code
     * change, which is the point: the sign-in mode each component starts on
     * follows this flag, so turning it off cannot leave a dialog with no fields
     * in it.
     */
    socialAndOtpAuthEnabled: true,

  /*
   * Google reCAPTCHA v3 site key — public by design, it identifies the key pair
   * to Google and is visible in the page source either way. The SECRET key is
   * the server's (RECAPTCHA_SECRET_KEY) and must never appear here.
   *
   * Empty switches the browser side off. That does not disable the check: the
   * backend still expects a token, so leaving this blank while
   * RECAPTCHA_ENABLED is true on the server blocks every sign-in. Turn the
   * whole feature off from the server flag, not from here.
   */
  recaptchaSiteKey: '6LfYsswtAAAAAE85LGLdy9QTtEqceccdHptNMheM',

    showBanner: true,
    // >>> TEMPORARY — search routed to search-exclusive-new.php <<<
    // To revert: delete the three TEMP lines below and uncomment the
    // three ORIGINAL lines beside them.
  // NOT self-contained: the same work added a searchCollections fallback to
  // api/budget/exclusive.service.ts and shared/classes/search-collections.ts.
  // Reverting only this file leaves that fallback in place.
    // ORIGINAL: searchApiUrl: 'https://api.indiapicture.in/search-indiapicture-new-website.php',
    searchApiUrl: 'https://api.indiapicture.in/search-exclusive-new.php',   // TEMP
    contributorUrl: 'https://api.indiapicture.in/contributor-profile',

    // >>> TEMPORARY — EDITORIAL search routed to search-exclusive-new.php <<<
    // To revert: delete the TEMP line(s) and uncomment the ORIGINAL beside them.
    // ORIGINAL: searchEdiApiUrl: 'https://api.indiapicture.in/apiibudgetphoto/ip_api/search-indiapicture-new.php',
    searchEdiApiUrl: 'https://api.indiapicture.in/apiibudgetphoto/ip_api/search-exclusive-new.php',   // TEMP
    cashfreeUrl: 'https://indiapicture.com/api/api/indiapicture/auth/cashfree-checkout/',
    cashfreeResponseUrl: 'https://indiapicture.com/api/api/indiapicture/',

    // indiapicture search
    // ORIGINAL: searchIndiapictureApiUrl: 'https://api.indiapicture.in/search-indiapicture-new-website.php',
    searchIndiapictureApiUrl: 'https://api.indiapicture.in/search-exclusive-new.php',   // TEMP
    // ORIGINAL: searchIndiapictureiApiUrl: 'https://api.indiapicture.in/apiibudgetphoto/ip_api/search-indiapicture-new.php',
    searchIndiapictureiApiUrl: 'https://api.indiapicture.in/apiibudgetphoto/ip_api/search-exclusive-new.php',   // TEMP

    //indiapicturebudget.com
    // ORIGINAL: searchIndiapictureBudgetApiurl: 'https://api.indiapicture.in/search.ibudgetphoto-new.php',
    searchIndiapictureBudgetApiurl: 'https://api.indiapicture.in/search-exclusive-new.php',   // TEMP
    similarIndiapictureBudgetUrl: 'https://api.indiapicture.in/similar.ibudgetphoto-new.php',



    //  exclusive urls
    ccAvenueResponseUrl: 'https://indiapicture.com/api/api/indiapicture/',
    merchant: '213313',
    accessCode: 'AVBS02GD63AJ23SBJA',
    displayCollectionName: 0,
    contributorApiUrl: "https://submission.mahatta.com/api/api/unauth",

    // serachCollections: "25,22,12,24,197,21,207,23,220,11,205,218,26,14,222,225,219,13,208,216,217,179,124,213,212,41,144,182,116,72,154,187,62,88,215,223,214,221,132,161,93,130"
  serachCollections: "25,22,12,24,197,21,207,23,220,11,205,218,26,14,222,225,219,13,208,216,217,179,213,212,72,215,223,214"

  };

// export const environment = {
//     production: true,
//     demo: 'demo1',
//     SERVER_URL: 'http://localhost:1337',
//     backendUrl: 'https://beta.indiapicture.in/api/api/indiapicture/',
//     siteadminUrl: 'https://frontadmin.indiapicture.in/api/api/unauth/',
//     frontUrl: 'https://beta.indiapicture.in',
//     searchhint: 'https://api.indiapicture.in/search.hint.php',
//     headerType: 'banner',
//     showBanner: true,
//     searchApiUrl: 'https://api.indiapicture.in/search-indiapicture-new-website.php',
//     contributorUrl: 'https://api.indiapicture.in/contributor-profile',
//     searchEdiApiUrl: 'https://api.indiapicture.in/apiibudgetphoto/ip_api/search-indiapicture-new.php',
//     cashfreeUrl: 'https://beta.indiapicture.in/api/api/indiapicture/auth/cashfree-checkout/',
//     cashfreeResponseUrl: 'https://beta.indiapicture.in/api/api/indiapicture/',
// };